import * as Raven from 'raven-js';

Raven
  .config('https://2dfb1960b44a415db2dcaaca7a9b6485@sentry.io/193777')
  .install();

export class RavenErrorHandler implements ErrorHandler {
  handleError(err:any) : void {
    Raven.captureException(err);
  }
}

import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';

import { FormService } from './form.service';
import { AppComponent } from './app.component';

import { SurveyContainerComponent } from './survey-container/survey-container.component';

import { ScreenIntroComponent } from './screen-intro/screen-intro.component';
import { ScreenIntermediateComponent } from './screen-intermediate/screen-intermediate.component';
import { ScreenFinishComponent } from './screen-finish/screen-finish.component';

import { SupportIconsComponent } from './support-icons/support-icons.component';
import { SupportCategoriesComponent } from './support-categories/support-categories.component';
import { CircularSliderComponent }  from './circular-slider/circular-slider.component';


const appRoutes: Routes = [
  { path: '',
    component: SurveyContainerComponent
  }
];

@NgModule({
  declarations: [
    AppComponent,
    CircularSliderComponent,
    SurveyContainerComponent,
    ScreenIntroComponent,
    ScreenIntermediateComponent,
    ScreenFinishComponent,
    SupportIconsComponent,
    SupportCategoriesComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    RouterModule.forRoot(appRoutes)
  ],
  providers: [
    FormService,
    { provide: APP_BASE_HREF, useValue: '/mijnfeedbackapp' },
    { provide: ErrorHandler, useClass: RavenErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/app/app.module.ts